export default __webpack_public_path__ + "static/0136-32be3d77c81d36bc9522ff080b754d19.png";